import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';

elabs.MultiColumn = class {
  constructor(element) {
    this.view = element;

    const swiperElement = this.view.querySelector('.swiper');
    const slideCount = this.view.querySelectorAll('.swiper-slide').length;

    this.swiperSlider = new Swiper(swiperElement, {
      effect: 'slide',
      loop: false,
      autoHeight: true,
      slidesPerView: slideCount > 1 ? 2 : 1,
      breakpoints: {
        900: {
          slidesPerView: slideCount < 3 ? slideCount : 3,
        },
        1200: {
          slidesPerView: slideCount < 4 ? slideCount : 4,
        },
        1500: {
          slidesPerView: slideCount < 5 ? slideCount : 5,
        },
        1800: {
          slidesPerView: slideCount < 6 ? slideCount : 6,
        },
      },
      controller: {
        control: null,
      },
      on: {
        init: (swiperSlider) => {
          this.showHideNavButtons(swiperSlider);
        },
        breakpoint: (swiperSlider) => {
          this.showHideNavButtons(swiperSlider);
        },
        resize: (swiperSlider) => {
          this.showHideNavButtons(swiperSlider);
        },
        slideChange: (swiperSlider) => {
          this.showHideNavButtons(swiperSlider);
        },
      },
    });

    this.wireEvents();
  }

  wireEvents = () => {
    // Add any event listeners if needed
    const nextButton = this.view.querySelector('.el-multi-column__nav-button--next');
    if (nextButton) {
      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.swiperSlider.slideNext();
      });
    }
    const prevButton = this.view.querySelector('.el-multi-column__nav-button--prev');
    if (prevButton) {
      prevButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.swiperSlider.slidePrev();
      });
    }
  };

  showHideNavButtons = (swiperSlider) => {
    const prev = this.view.querySelector('.el-multi-column__nav-button--prev');
    const next = this.view.querySelector('.el-multi-column__nav-button--next');

    prev?.classList.toggle('el-multi-column__nav-button--disabled', swiperSlider.isBeginning);
    next?.classList.toggle('el-multi-column__nav-button--disabled', swiperSlider.isEnd);
  };
};

elabs.onJavascriptReady(() => {
  document.querySelectorAll('.el-multi-column-container').forEach((element) => {
    void new elabs.MultiColumn(element);
  });
});
